// extracted by mini-css-extract-plugin
module.exports = {"root":"common_root__G9bbW","title":"common_title__pUCaE","subtitle":"common_subtitle__3IYxk","background":"common_background__r05eE"};